import { flatMap } from 'lodash';
import { connect } from 'react-redux';

import { appActions, currentSelectedApi } from 'app/developer-v3/selectors';
import { deleteAction } from 'app/developer-v3/Actions';

import ActionsPage from './ActionsPage';
import { isExternalAction } from './utils';

const applyServiceTypeToActions = (services, serviceType) => {
  return services.map(service => ({ ...service, serviceType }));
};

const getAppActions = state =>
  flatMap(appActions(state), applyServiceTypeToActions);

const mapStateToProps = state => {
  const actions = getAppActions(state);
  const internalActions = actions.filter(action => !isExternalAction(action));
  const externalActions = actions.filter(isExternalAction);

  return {
    actions: [...internalActions, ...externalActions],
    selected_api: currentSelectedApi(state),
  };
};

export default connect(mapStateToProps, { deleteAction })(ActionsPage);
